<div class="search-results" [formGroup]="form()">
  <app-typeahead
    [controlName]="name()"
    [form]="form()"
    (searchChanged)="searchChangedDebounced()"
    [resultSelected]="ibanSelectedInternal"
    [loading]="loading()"
    [results]="ibanResults()"
    mask="AA00 0000 0000 0000 0000 99"
    [disableTypeahead]="disableTypeahead()"
    [copyWithoutWhitespace]="true"
    [canNavigateByKeys]="true"
    (keyboardSelected)="handleKeyboadSelected($event)"
    [resultTemplate]="itemTpl"
    ngDefaultControl
  ></app-typeahead>

  <ng-template #itemTpl let-item>
    <div
      [class.has-click]="!item.closed"
      class="is-flex is-justify-content-center is-align-items-center"
      (click)="handleResultSelected(item)"
    >
      @if (item.closed) {
        <fino-icon icon="Lock 6" class="has-text-danger mr-4"></fino-icon>
      }
      <div class="is-flex is-flex-direction-column">
        <strong [class.has-text-grey-light]="item.closed"
          >{{ item[name()] | iban }}
          @if (item.client) {
            <span>({{ item.client }})</span>
          }
        </strong>
        <small class="has-text-centered" [class.has-text-grey-light]="item.closed">{{
          item.received | date: 'dd.MM.yy, HH:mm'
        }}</small>
      </div>
    </div>
  </ng-template>

  @if (showCounterResults()) {
    <section class="box typeahead-results-container">
      <div class="is-flex is-justify-content-flex-end pr-2 pt-1 typeahead-header">
        <fino-icon
          (click)="hideCounterResults()"
          icon="Close"
          class="has-text-grey has-click is-small"
        ></fino-icon>
      </div>
      @for (counterResult of counterResults(); track $index) {
        <div
          class="typeahead-result"
          [class.has-background-grey-lighter]="$index === selectedIndex()"
        >
          <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: counterResult }">
          </ng-container>
        </div>
      }
    </section>
  }
</div>
